import React from "react";
import contextProvider from "../../contextProvider";

import _ReactOBaseComponent, { withDefinedContext } from "../_ReactOBaseComponent";

const context_exposed_methods = ["scrollTop"];

class _LayoutBody extends _ReactOBaseComponent {
  constructor(props) {
    super(props);
    this.state = {};
  }

  scrollTop() {
    document.getElementById("_layout-body").scrollTo(0, 0);
  }

  /////////////////////////
  //	Lifecycle methods
  //

  onComponentDidMount() {}

  onComponentWillUnmount() {}

  onRender() {
    return (
      <div
        id="_layout-body"
        className="_layout-body"
        style={{
          marginTop: this.context._LayoutPage.getSafeBoundaries().top + "px",
          ...(this.getAppContext().media.isDesktopSidebarOpen
            ? { marginLeft: this.context._LayoutPage.getSafeBoundaries().left + "px" }
            : { left: this.context._LayoutPage.getSafeBoundaries().left + "px" }),
          paddingBottom: this.context._LayoutPage.getSafeBoundaries().top + "px",
        }}
      >
        <div // Fix - per Window Edge
          style={{
            marginBottom: this.context._LayoutPage.getSafeBoundaries().top + "px",
          }}
        >
          {React.Children.map(this.props.children, (_C_child, _C_idx) => {
            return _C_child ? React.cloneElement(_C_child, {}) : null;
          })}
        </div>
      </div>
    );
  }
}

export default contextProvider(
  withDefinedContext(_LayoutBody, "_LayoutBody", context_exposed_methods),
  {
    retrieve: ["_LayoutPage"],
  }
);
